const MEDIA_QUERIES = {
    TOUCH_ONLY: "(hover: none)",
    ORIENTATION_LANDSCAPE: "(orientation: landscape)",
    ORIENTATION_PORTRAIT: "(orientation: portrait)"
};

export default {
    get isTouchOnly(): boolean {
        return window.matchMedia(MEDIA_QUERIES.TOUCH_ONLY).matches;
    },

    get isLandscape(): boolean {
        return window.matchMedia(MEDIA_QUERIES.ORIENTATION_LANDSCAPE).matches;
    },

    get isPortrait(): boolean {
        return window.matchMedia(MEDIA_QUERIES.ORIENTATION_PORTRAIT).matches;
    }
};
